import * as constants from "./InSilicoPredictionsConstants";
import * as urls from "./InSilicoPredictionsUrls";

export const inSilicoDbsList = (inSilicoThresholds) => [
  {
    type: "dbItems",
    name: "SIFT",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "sift",
    url: urls.siftUrl,
    thresholds: inSilicoThresholds,
  },
  {
    type: "dbItems",
    name: "SIFT4G",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "sift4g",
    url: urls.sift4gUrl,
  },
  {
    type: "dbItems",
    name: "PROVEAN",
    prediction: constants.PREDICTIONS_GROUP_2,
    prefix: "provean",
    url: urls.proveanUrl,
  },
  {
    type: "dbItems",
    name: "MVP",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "mvp",
    url: urls.mvpUrl,
    thresholds: inSilicoThresholds,
  },
  {
    type: "dbItems",
    name: "MutPred",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "mutpred",
    url: urls.mutpredUrl,
    thresholds: inSilicoThresholds,
  },
  {
    type: "dbItems",
    name: "PrimateAI",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "primateai",
    url: urls.primateaiUrl,
  },
  {
    type: "dbItems",
    name: "BayesDel noAF",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "bayesdel_noaf",
    url: urls.bayesdelUrl,
    isMeta: true,
  },
  {
    type: "dbItems",
    name: "BayesDel addAF",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "bayesdel_addaf",
    url: urls.bayesdelUrl,
    isMeta: true,
  },
  {
    type: "dbItems",
    name: "LIST-S2",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "list_s2",
    url: urls.lists2Url,
  },
  {
    type: "dbItems",
    name: "MutationTaster",
    prediction: constants.PREDICTIONS_GROUP_3,
    prefix: "mutationtaster",
    url: urls.MutationTasterUrl,
    thresholds: false,
    helptext: {
      pred: "MutationTaster prediction",
      score: "MutationTaster p value",
    },
  },
  {
    type: "dbItems",
    name: "Mutation assessor",
    prediction: constants.PREDICTIONS_GROUP_6,
    prefix: "mutationassessor",
    url: urls.MutationAssessorUrl,
  },
  {
    type: "dbItems",
    name: "FATHMM",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "fathmm",
    url: urls.fathmmUrl,
  },
  {
    type: "dbItems",
    name: "FATHMM-MKL",
    prediction: constants.PREDICTIONS_GROUP_2,
    prefix: "fathmm_mkl_coding",
    url: urls.fathmmMklUrl,
  },
  {
    type: "dbItems",
    name: "FATHMM-XF",
    prediction: constants.PREDICTIONS_GROUP_2,
    prefix: "fathmm_xf_coding",
    url: urls.fathmmXfUrl,
  },
  {
    type: "dbItems",
    name: "LRT",
    prediction: constants.PREDICTIONS_GROUP_4,
    prefix: "lrt",
    url: urls.LRTUrl,
  },
  {
    type: "dbItems",
    name: "DEOGEN2",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "deogen2",
    url: urls.deogen2Url,
  },
  {
    type: "dbItems",
    name: "M-CAP",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "m_cap",
    url: urls.mcapUrl,
  },
  {
    type: "cadd",
    name: "CADD",
    prefix: "cadd",
    thresholds: inSilicoThresholds,
  },
  {
    type: "dann",
    name: "DANN",
    prefix: "dann",
    thresholds: inSilicoThresholds,
    url: urls.dannUrl,
  },
  {
    type: "dbItems",
    name: "MetaLR",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "metalr",
    isMeta: true,
  },
  {
    type: "dbItems",
    name: "MetaSVM",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "metasvm",
    isMeta: true,
  },
  {
    type: "dbItems",
    name: "MetaRNN",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "metarnn",
    url: urls.metaRnnUrl,
    isMeta: true,
  },
  {
    type: "dbItems",
    name: "REVEL",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "revel",
    url: urls.revelUrl,
    thresholds: inSilicoThresholds,
    isMeta: true,
  },
  { type: "aloft", name: "ALoFT" },
  { type: "eigen", name: "EIGEN" },
  { type: "eigenpc", name: "EIGEN PC" },
  {
    type: "dbscSNV",
    name: "dbnsfp_dbscsnv",
    prefix: "scsnv_ada",
    thresholds: inSilicoThresholds,
  },
];
